export default {
  path: '/wecode/certify',
  auth: false,
  preload: false,
  key: 'certify',
  component: () => import('./index')
};
